<template>
    <form @submit.prevent="callToPickupEMST()">
        <template>
            <template v-if="pickup.completed">
                <div>
                    <div class="col-lg-12 text-center">
                        <span class="fa-stack fa-2x" 
                        v-bind:class="{ 'text-success': !pickup.error, 'text-danger': pickup.error }">
                            <i class="fa fa-circle fa-stack-2x"></i>
                            <i class="fa fa-truck fa-stack-1x fa-inverse"></i>
                        </span>
                        <br/>
                        <p v-if="pickup.error" class="text-danger">{{pickup.error}}</p>
                        <p v-else>เรียกรถเข้ารับสำเร็จ</p>                    
                    </div>
                </div>
            </template>
            <template v-else-if="!pickup.showButton">
              <div>
                <p class="text-center">
                  ขณะนี้ยังไม่สามารถกดเรียกขนส่งเข้ารับได้<br/>กรุณากดเรียกใหม่ภายหลังเวลา 14.00 น.
                </p>
              </div>
            </template>
            <template v-else>
                <div>
                    <div class="col-lg-12">
                        <div class="alert alert-shippop-info">
                            เปิดรายการ Booking ของขนส่งไปรษณีย์ไทย เพื่อให้พนักงานสามารถรับพัสดุได้ 3 กรณีดังนี้
                            <ul>
                                <li>ขนส่งตัดรอบการเรียกเข้ารับ 11:00 น. และเข้ารับภายในวันไม่เกิน 15:00 น. (หรือตามเวลาที่นัดหมายกับพนักงาน)</li>
                                <li>พนักงานจะเป็นผู้ติดต่อก่อนเดินทางเข้ารับ</li>
                                <li>สำหรับไปรษณีย์ไทยสามารถระบุวันที่ และเวลาให้เข้ารับล่วงหน้าได้</li>
                                <li>เงื่อนไขการเข้ารับบางพื้นที่อาจแตกต่างกัน เนื่องจากเป็นการจัดการโดยศูนย์ไปรษณีย์แต่ละพื้นที่</li>
                            </ul>
                        </div>

                        <div class="form-group">
                            <label>
                                <span class="text-danger">*</span> หมายเลขพัสดุ
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="หมายเลขพัสดุของขนส่งไปรษณีย์ไทย เช่น EB000000000TH"
                                :class="{ 'is-invalid': ($v.pickup.trackingCode.$dirty && !$v.pickup.trackingCode.isTrackingCode) || pickup.submitted && ($v.pickup.trackingCode.$invalid) }"
                                v-model="$v.pickup.trackingCode.$model"
                                :readonly="busy"
                            />
                        </div>
                    </div>

                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>
                                <span class="text-danger">*</span> จำนวนพัสดุ
                            </label>
                            <input
                                type="number"
                                min="1"
                                class="form-control"
                                placeholder="จำนวนพัสดุ"
                                :class="{ 'is-invalid': pickup.submitted && $v.pickup.numOfParcel.$invalid }"
                                :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                v-model="pickup.numOfParcel"
                                :readonly="busy"
                            />
                        </div>
                    </div>

                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>
                                <span class="text-danger">*</span> วันที่นัดหมาย
                            </label>
                            <input
                                type="date"
                                class="form-control"
                                :min="minDate"
                                :class="{ 'is-invalid': pickup.submitted && $v.pickup.date.$invalid }"
                                v-model="pickup.date"
                                :readonly="busy"
                            />
                        </div>
                    </div>

                    <div class="col-lg-12">
                        <div class="form-group">
                            <label>
                                <span class="text-danger">*</span> เวลานัดหมาย
                            </label>
                            <input
                                type="time"
                                class="form-control"
                                :class="{ 'is-invalid': pickup.submitted && $v.pickup.time.$invalid }"
                                v-model="pickup.time"
                                :readonly="busy"
                            />
                        </div>
                    </div>
                </div>
            </template>
        
            <div slot="modal-footer" class="w-100 text-right" v-if="!pickup.completed && pickup.showButton">
                <b-button variant="secondary" @click="closeModalPickup">ยกเลิก</b-button>
                <b-button variant="success" type="submit" :disabled="$v.pickup.trackingCode.$invalid || $v.pickup.numOfParcel.$invalid || $v.pickup.date.$invalid || $v.pickup.time.$invalid">ยืนยัน</b-button>
            </div>

        </template>
    </form>
</template>

<script>
    import moment from "moment"
    import { required } from "vuelidate/lib/validators"
    import validatePop from "../../plugins/validatePop.js"

    export default {
        data() {
            return {
                minDate: moment().format("YYYY-MM-DD"),
                picker: [],
                pickup: {
                    trackingCode: '',
                    numOfParcel: 1,
                    date: moment().format("YYYY-MM-DD"),
                    time: '',
                    submitted: false,
                    completed: false,
                    showButton: true //new Date().getHours()>13?true:false
                },
                busy: false,
            };
        },
        validations: {
            pickup: {
                numOfParcel: { required },
                trackingCode: { required, 
                    isTrackingCode(value) {
                    return (
                      /^\w+(TH)$/ig.test(value)
                    );
                    } 
                },
                date: { required },
                time: { required }
            }
        },
        methods: {
            callToPickupEMST() {
                this.pickup.submitted = true;
                this.busy = true;
                
                this.$http
                    .post(
                    this.$API_URL + "/calltopickup",
                    {
                        tracking_code: this.pickup.trackingCode,
                        num_of_parcel: this.pickup.numOfParcel,
                        datetime_pickup: moment(`${this.pickup.date} ${this.pickup.time}`).format('YYYY-MM-DD HH:mm:ss'),
                        // courier_code: 'EMST'
                    },
                    {
                        headers: {
                            Token: localStorage.getItem("access_token")
                        }
                    }
                    )
                    .then(res => {
                    const result = res.data;
                    let checkError = validatePop(res);
                    this.pickup.completed = true;
                    this.$v.$reset();
                    if (!checkError.status) {
                        if (checkError.notices == "token is expired") {
                        this.$router.push("/logout");
                        }
                        this.pickup.error = checkError.msg;
                        this.busy = false;
                        return false;
                    }
                    if (result.status) {
                        let courierPicker = result.data.data
                        if (courierPicker.length) {
                        courierPicker = this.IsJsonString(result.data.data.response_data)?JSON.parse(result.data.data.response_data):courierPicker;
                        } else {
                        courierPicker = this.IsJsonString(courierPicker.response_data)?JSON.parse(courierPicker.response_data).data:courierPicker;
                        }
                        // this.picker = []; 
                        // courierPicker.map((x) => {
                        // const pickupInfo = x.pickupInfo;
                        // this.picker.push({
                        //     staffName: pickupInfo.staffName,
                        //     staffPhone: pickupInfo.staffPhone,
                        //     created_at: result.data.data.created_at
                        // })
                        // })
                    }

                    this.busy = false
                    })
            },
            closeModalPickup() {
                this.$emit('cancel')
            }
        }
    }
</script>